import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LibInfoIconModule } from '../icons/lib-info-icon/lib-info-icon.module';
import { LibAccordionRefreshModule } from '../lib-accordion-refresh/lib-accordion-refresh.module';
import { LibAccordionModule } from '../lib-accordion/lib-accordion.module';
import { LibButtonModule } from '../lib-button/lib-button.module';
import { LibSpinnerModule } from '../lib-spinner/lib-spinner.module';
import { LibChevronMoreIconModule } from './../icons/lib-chevron-more-icon/lib-chevron-more-icon.module';
import { LibAccountCardComponent } from './lib-account-card.component';

@NgModule({
  declarations: [LibAccountCardComponent],
  imports: [
    CommonModule,
    LibSpinnerModule,
    LibButtonModule,
    LibInfoIconModule,
    LibAccordionModule,
    LibAccordionRefreshModule,
    MatTooltipModule,
    LibChevronMoreIconModule,
  ],
  exports: [LibAccountCardComponent],
})
export class LibAccountCardModule {}
